import { useNavigate } from "react-router-dom";
import styles from "./styles.module.scss";
import vectorIcon from "./../../../assets/_VectorIcon_.svg";
import React, { useEffect, useState } from "react";
import { IProjectType } from "../../../@types/project/project.type";
import { FormProjects } from "../components/FormProject";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import { HiredProject } from "../HiredProject";
import { PlannedProject } from "../PlannedProject";
import { ImplementedProject } from "../ImplementedProject";
import { searchConfigurationsByKeys } from "../../../services/api/Configurations/ConfigurationService";
import { IApiResponse } from "../../../@types/api-response.type";
import { IConfiguration } from "../../../@types/configuration.type";
import usePermission from "../../../hooks/usePermission";
import { FeatureStatic } from "../../../@types/statics/feature.static";

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

interface ProjectProps {
  pageType: "create" | "update";
  projectData?: IProjectType;
}

function CustomTabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 0 }}>{children}</Box>}
    </div>
  );
}

export const Project: React.FC<ProjectProps> = ({ pageType, projectData }) => {
  const navigate = useNavigate();
  const [value, setValue] = useState(0);
  const [isFinancialEnabled, setIsFinancialEnabled] = useState<boolean>(false);
  const permissionsFinancialContracted = usePermission(FeatureStatic.financialContracted.id);
  const permissionsFinancialPlanned = usePermission(FeatureStatic.financialPlanned.id);

  useEffect(() => {
    const fetchConfig = async () => {

      const response = await searchConfigurationsByKeys(["CONFIGURATION_ENABLE_FINANTIAL"]) as IApiResponse<IConfiguration[]>;
      if (response.statusCode === 200) {
        setIsFinancialEnabled(response.result[0].value === "true");
      }
    };
    fetchConfig();
  }, []);


  const handleChange = (_: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };


  function a11yProps(index: number) {
    return {
      id: `simple-tab-${index}`,
      'aria-controls': `simple-tabpanel-${index}`,
    };
  }

  return (
    <>
      <div className={styles.project}>
        <div className={styles.back}>
          <Button className={styles.button} onClick={() => navigate("/projects")}>
            {vectorIcon && <img src={vectorIcon} />}
            Voltar a tela anterior
          </Button>
        </div>
        <div className={styles.title}>
          <h1>{pageType === "update" ? `${projectData?.name}` : "Novo Projeto"}</h1>
        </div>
        <div>
          <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
            <Tabs
              value={value}
              onChange={handleChange}
              aria-label="basic tabs example"
              classes={{ indicator: styles["MuiTabs-indicator"] }}
            >
              <Tab label="Dados do Projeto" {...a11yProps(0)} className={styles.tab} />
              <Tab
                label="Contratado"
                {...a11yProps(1)}
                className={styles.tab}
                sx={{ display: isFinancialEnabled && permissionsFinancialContracted.canView(undefined) ? "flex" : "none !important" }}
              />
              <Tab
                label="Planejado"
                {...a11yProps(2)}
                className={styles.tab}
                sx={{ display: isFinancialEnabled && permissionsFinancialPlanned.canView(undefined) ? "flex" : "none !important" }}
              />
              <Tab
                label="Alocado"
                {...a11yProps(3)}
                className={styles.tab}
                sx={{ display: isFinancialEnabled ? "flex" : "none !important" }}

              />
            </Tabs>
          </Box>
          <CustomTabPanel value={value} index={0}>
            <FormProjects pageType={pageType} projectData={projectData} />
          </CustomTabPanel>

          {isFinancialEnabled && (
            <>
              <CustomTabPanel value={value} index={1}>
                <HiredProject projectId={projectData?.id} />
              </CustomTabPanel>
              <CustomTabPanel value={value} index={2}>
                <PlannedProject projectId={projectData?.id} />
              </CustomTabPanel>
              <CustomTabPanel value={value} index={3}>
                <ImplementedProject projectId={projectData?.id} />
              </CustomTabPanel>
            </>
          )}
        </div>
      </div>
    </>
  );
};
